// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import React from "react";

export interface RfqConfirmationPageContainerStyles {}

export const rfqConfirmationPageContainerStyles: RfqConfirmationPageContainerStyles = {};

const styles = rfqConfirmationPageContainerStyles;

const RfqConfirmationPageContainer = ({ id }: WidgetProps) => {
    return <OrderLayout id={id} />;
};

const widgetModule: WidgetModule = {
    component: RfqConfirmationPageContainer,
    definition: {
        displayName: "Page Container",
        group: "RFQ Quote Confirmation",
        allowedContexts: ["RfqConfirmationPage"],
    },
};
export default widgetModule;
